module.exports = __webpack_public_path__ + "img/2.9e147a5d.png";